import IconButton from '@alltrails/shared/denali/components/IconButton';
import Expand from '@alltrails/shared/icons/Expand';
import { FormattedMessage } from '@alltrails/shared/react-intl';
import { LanguageSupportUtil } from '../../../../../utils/language_support_util';
import { ServerCommunicationUtil } from '../../../../../utils/server_communication_util';

const createReactClass = require('create-react-class');

const FullscreenCustomListTitle = createReactClass({
  getInitialState() {
    return {
      editing: false,
      saving: false,
      newListTitle: this.props.list ? this.props.list.title : null,
      errorMsg: null
    };
  },
  handleEditClick() {
    this.setState({ editing: !this.setState.editing });
  },
  handleCancelClick() {
    const newListTitle = this.props.list ? this.props.list.title : null;
    this.setState({ newListTitle, errorMsg: null, editing: false });
  },
  handleDeleteClick() {
    if (!confirm(this.props.intl.formatMessage({ defaultMessage: 'Are you sure you want to delete this list?' }))) return;
    const url = `/api/alltrails/lists/${this.props.list.id}`;
    ServerCommunicationUtil.deleteApiEndpoint(url, {}, this.handleDeleteSuccess, this.handleDeleteError, this.handleDeleteComplete);
    this.setState({ saving: true });
  },
  handleDeleteSuccess() {
    window.location = LanguageSupportUtil.wrapUrlSafe('/explore');
  },
  handleDeleteError() {
    this.setState({ errorMsg: this.props.intl.formatMessage({ defaultMessage: 'Error, please try again' }) });
  },
  handleDeleteComplete() {},
  handleSaveClick() {
    this.setState({ saving: true });
    if (this.props.list) {
      const url = `/api/alltrails/lists/${this.props.list.id}`;
      // Use name due to API fields consistency
      ServerCommunicationUtil.putApiEndpoint(
        url,
        { name: this.state.newListTitle },
        this.handleSaveSuccess,
        this.handleSaveError,
        this.handleSaveComplete
      );
    }
  },
  handleSaveSuccess(data) {
    // only saves title
    this.setState({ saving: false, editing: false });
    if (this.props.list) {
      const newListTitle = data.lists[0].name;
      const newSlug = data.lists[0].slug;
      this.props.handleListTitleUpdate(newListTitle, newSlug);
      window.location.href = LanguageSupportUtil.wrapUrlSafe(`/explore/list/${newSlug}`);
    } else {
      window.location.reload();
    }
  },
  handleSaveError() {
    this.setState({ saving: false, errorMsg: this.props.intl.formatMessage({ defaultMessage: 'Error, please try again' }) });
  },
  handleSaveComplete() {},
  handleListKeyUp(e) {
    if (e.keyCode == 13) {
      this.handleSaveClick();
      return false;
    }
  },
  handleListTitleChange(e) {
    this.setState({ newListTitle: e.target.value });
  },
  render() {
    const listTitleClasses = 'list-title xlate-none';
    if (this.props.list) {
      let editButtonsSpan = null;
      if (this.state.editing && this.state.errorMsg) {
        editButtonsSpan = (
          <span className="edit-buttons">
            <span className="link" onClick={this.handleCancelClick}>
              <FormattedMessage defaultMessage="Cancel" />
            </span>
          </span>
        );
      } else if (this.state.editing && !this.state.saving) {
        editButtonsSpan = (
          <span className="edit-buttons">
            <span className="edit-button-link" onClick={this.handleSaveClick}>
              <FormattedMessage defaultMessage="Save" />
            </span>
            <span className="edit-button-link-delete" onClick={this.handleDeleteClick}>
              <FormattedMessage defaultMessage="Delete" />
            </span>
            <span className="edit-button-link-cancel" onClick={this.handleCancelClick}>
              <FormattedMessage defaultMessage="Cancel" />
            </span>
          </span>
        );
      } else if (this.state.saving) {
        editButtonsSpan = (
          <span className="edit-buttons">
            <span>
              <FormattedMessage defaultMessage="Saving..." />
            </span>
          </span>
        );
      }
      if (this.props.canEdit) {
        if (this.state.editing && this.state.errorMsg) {
          return (
            <div className={listTitleClasses}>
              <input
                className="result-title"
                type="text"
                value={this.state.newListTitle}
                onChange={this.handleListTitleChange}
                onKeyUp={this.handleListKeyUp}
              />
              {editButtonsSpan}
              <span>{this.state.errorMsg}</span>
            </div>
          );
        }
        if (this.state.editing) {
          return (
            <div className={listTitleClasses}>
              <input
                className="result-title"
                type="text"
                value={this.state.newListTitle}
                onChange={this.handleListTitleChange}
                onKeyUp={this.handleListKeyUp}
              />
              {editButtonsSpan}
            </div>
          );
        }
        var expandButton = (
          <span className="floatright">
            <IconButton
              icon={{ Component: Expand }}
              linkInfo={{ href: LanguageSupportUtil.wrapUrlSafe(`/lists/${this.props.list.slug}`) }}
              testId="expand-list-icon"
              title="Expand"
              size="sm"
              variant="flat"
            />
            <a className="expand" href={LanguageSupportUtil.wrapUrlSafe(`/lists/${this.props.list.slug}`)}>
              <FormattedMessage defaultMessage="View list details" />
            </a>
          </span>
        );
        return (
          <div className={listTitleClasses}>
            <div className="titleContainer">
              <h1 className="result-title short-ellipsis" itemProp="name" title={this.props.list.title}>
                {this.props.list.title}
              </h1>
              <span className="link-edit" onClick={this.handleEditClick}>
                <FormattedMessage defaultMessage="Edit" />
              </span>
            </div>
            {expandButton}
          </div>
        );
      }

      expandButton = (
        <span className="floatright">
          <IconButton
            icon={{ Component: Expand }}
            linkInfo={{ href: LanguageSupportUtil.wrapUrlSafe(`/lists/${this.props.list.slug}`) }}
            testId="expand-list-icon"
            title="Expand"
            size="sm"
            variant="flat"
          />
          <a className="expand" href={LanguageSupportUtil.wrapUrlSafe(`/lists/${this.props.list.slug}`)}>
            <FormattedMessage defaultMessage="View list details" />
          </a>
        </span>
      );
      return (
        <div className={listTitleClasses}>
          <h1 className="result-title long-ellipsis" title={this.props.list.title}>
            {this.props.list.title}
          </h1>
          {expandButton}
        </div>
      );
    }

    if (this.state.editing && this.state.errorMsg) {
      editButtonsSpan = (
        <span className="edit-buttons">
          <span className="link" onClick={this.handleCancelClick}>
            <FormattedMessage defaultMessage="Cancel" />
          </span>
        </span>
      );
    } else if (this.state.editing && !this.state.saving) {
      editButtonsSpan = (
        <span className="edit-buttons">
          <span className="btn simple btn-slim blue" onClick={this.handleSaveClick}>
            <FormattedMessage defaultMessage="Save" />
          </span>
          <span className="link" onClick={this.handleCancelClick}>
            <FormattedMessage defaultMessage="Cancel" />
          </span>
        </span>
      );
    } else if (this.state.saving) {
      editButtonsSpan = (
        <span className="edit-buttons">
          <span>
            <FormattedMessage defaultMessage="Saving..." />
          </span>
        </span>
      );
    }
    if (this.props.canEdit) {
      if (this.state.editing) {
        return (
          <div className={`${listTitleClasses} result-btn-box`}>
            <h1 className="result-title" title={this.props.builtInTitle}>
              {this.props.builtInTitle}
            </h1>
            {editButtonsSpan}
          </div>
        );
      }
      return (
        <div className={`${listTitleClasses} result-btn-box`}>
          <div className="titleContainer">
            <h1 className="result-title short-ellipsis" title={this.props.builtInTitle}>
              {this.props.builtInTitle}
            </h1>
            <span className="link-edit" onClick={this.handleEditClick}>
              <FormattedMessage defaultMessage="Edit" />
            </span>
          </div>
          {editButtonsSpan}
        </div>
      );
    }
    return (
      <div className={listTitleClasses}>
        <h1 className="result-title" title={this.props.builtInTitle}>
          {this.props.builtInTitle}
        </h1>
      </div>
    );
  }
});

export { FullscreenCustomListTitle };
